import { render, staticRenderFns } from "./DialogFormWrapper.vue?vue&type=template&id=24acba2d&scoped=true&"
import script from "./DialogFormWrapper.vue?vue&type=script&lang=js&"
export * from "./DialogFormWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DialogFormWrapper.vue?vue&type=style&index=0&id=24acba2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24acba2d",
  null
  
)

export default component.exports